/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseInfo} from '../models/LicenseInfo';
import type {LicenseShortInfo} from '../models/LicenseShortInfo';
import type {LicenseType} from '../models/LicenseType';

export interface GetAccountLicenses$Request {
    requestBody: Array<number>;
    licenseType?: LicenseType;
}

export interface GetAccountLicenses$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountLicensesRequest = createAction<PayloadData<void, GetAccountLicenses$Request>>('GET_LICENSE__GET_ACCOUNT_LICENSES__REQUEST');
export const getAccountLicensesSuccess = createAction<PayloadData<Array<LicenseShortInfo>, GetAccountLicenses$Request>>('GET_LICENSE__GET_ACCOUNT_LICENSES__SUCCESS');
export const getAccountLicensesFailure = createAction<PayloadData<Error, GetAccountLicenses$Request, true>>('GET_LICENSE__GET_ACCOUNT_LICENSES__FAILURE');

export const getAccountLicensesActions = [
    getAccountLicensesRequest,
    getAccountLicensesSuccess,
    getAccountLicensesFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {LicenseType} [meta.licenseType]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountLicenses = (meta: GetAccountLicenses$Request, config?: GetAccountLicenses$Config) => {
    const TRANSPORT_GET_PARAMS = {
        licenseType: meta.licenseType,
    };
    return {
        CALL_API: {
            types: getAccountLicensesActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/licenses/account`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetLicense$Request {
    licenseId: number;
}

export interface GetLicense$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseRequest = createAction<PayloadData<void, GetLicense$Request>>('GET_LICENSE__GET_LICENSE__REQUEST');
export const getLicenseSuccess = createAction<PayloadData<LicenseInfo, GetLicense$Request>>('GET_LICENSE__GET_LICENSE__SUCCESS');
export const getLicenseFailure = createAction<PayloadData<Error, GetLicense$Request, true>>('GET_LICENSE__GET_LICENSE__FAILURE');

export const getLicenseActions = [
    getLicenseRequest,
    getLicenseSuccess,
    getLicenseFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicense = (meta: GetLicense$Request, config?: GetLicense$Config) => {
    return {
        CALL_API: {
            types: getLicenseActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

